import React, {ReactElement, useState} from 'react';
import {useHistory} from 'react-router';
import sad from '../../../assets/images/sad.svg';
import {THANKYOU} from '../../../routes/route-constants';
type NegativeFeedbackProps = {
  onNoClick: (feedback:string) => void;
  onYesClick: (feedback:string) => void;
};
const NegativeFeedback: React.FC<NegativeFeedbackProps> = ({
  onNoClick,
  onYesClick,
}: NegativeFeedbackProps): ReactElement => {
  const navigate = useHistory();
  //   const handleOnNo = () => {
  //     navigate.replace(THANKYOU);
  //   };

  //   const handleOnYes = () => {
  //     navigate.replace(THANKYOU);
  //   };
const [getFeedback,setGetFeedback]= useState('');
//console.log(getFeedback);
  return (
    <div className="grid h-full place-items-center bg-feedback_blue mx-auto font-roboto rounded-lg ">
      {/* <img className="mt-4" src={landmark}/> */}
      <img className=" h-20 w-20 " src={sad} />
      <div className="mt-4">
        <p className="text-3xl font-light">Sorry to know!</p>
      </div>
      <div className=" flex flex-col rounded-lg bg-blue_four w-80 mt-4">
        <div className="flex">
          <div className="ml-4">
            <span className="font-bold text-xs font-roboto">
              Would you like to share your feedback
            </span>
          </div>
        </div>
        <textarea
        
          className=" bg-blue_four focus:outline-none font-roboto ml-4 mr-4 h-36"
          placeholder="Enter text here"
          value={getFeedback}
          onChange={e => setGetFeedback(e.target.value)}
        />
      </div>
      <div className="mt-12">
        <p className="text-base font-normal text-gray-500">
          Would you like us to contact you?
        </p>
      </div>
      <div className="mb-20 mt-4">
        <button
          className="w-40 h-12 mt-6 text-black font-bold focus:outline-none rounded-lg border border-royal_blue"
          type="submit"
          onClick={()=>onNoClick(getFeedback)} >
          No
        </button>
        &nbsp;
        <button
          className="w-40 h-12 mt-6 text-black font-bold focus:outline-none rounded-lg border border-royal_blue"
          type="submit"

          onClick={()=>onYesClick(getFeedback)} >
          Yes
        </button>
      </div>
    </div>
  );
};
export default NegativeFeedback;
